import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const FestiveBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  // Ganesh Chaturthi 2026 dates (adjust as needed)
  // Festival typically lasts 10 days, but we'll show banner for 1 week
  const BANNER_START_DATE = new Date('2026-09-13'); // Today
  const BANNER_END_DATE = new Date('2026-09-20');   // 1 week from today

  useEffect(() => {
    // Check if banner should be displayed
    const now = new Date();
    const shouldShow = now >= BANNER_START_DATE && now <= BANNER_END_DATE;
    
    // Check if user dismissed it (stored in localStorage)
    const dismissed = localStorage.getItem('ganesh-banner-dismissed-2026');
    
    setIsVisible(shouldShow && !dismissed);
  }, []);

  const handleDismiss = () => {
    setIsDismissed(true);
    setIsVisible(false);
    // Remember dismissal for this year
    localStorage.setItem('ganesh-banner-dismissed-2026', 'true');
  };

  if (!isVisible || isDismissed) {
    return null;
  }

  return (
    <div className="relative w-full bg-gradient-to-r from-orange-100 via-yellow-50 to-orange-100">
      {/* Banner Image */}
      <div className="container mx-auto px-4 py-6 md:py-8">
        <div className="relative rounded-2xl overflow-hidden shadow-2xl">
          <img
            src="/ganesh-chaturthi-banner.png"
            alt="गणेश चतुर्थी की शुभकामनाएं - Ganesh Chaturthi Wishes from Roastey Snacks"
            className="w-full h-auto"
            loading="eager"
          />
          
          {/* Close Button */}
          <button
            onClick={handleDismiss}
            className="absolute top-4 right-4 bg-white/90 hover:bg-white p-2 rounded-full shadow-lg transition-all duration-200 hover:scale-110"
            aria-label="Close banner"
          >
            <X className="w-5 h-5 text-gray-700" />
          </button>

          {/* Optional: Add a subtle animation */}
          <div className="absolute inset-0 bg-gradient-to-r from-orange-500/0 via-yellow-500/5 to-orange-500/0 animate-pulse pointer-events-none" />
        </div>

        {/* Festival Message (accessible text for SEO) */}
        <div className="text-center mt-4 hidden">
          <h2 className="text-2xl font-bold text-orange-800">
            गणेश चतुर्थी की शुभकामनाएं
          </h2>
          <p className="text-gray-700">
            Ganesh Chaturthi Wishes from Roastey Snacks - Special festive offers on healthy snacks
          </p>
        </div>
      </div>
    </div>
  );
};

export default FestiveBanner;
